/* RESPONSIBLE TEAM: team-workflows */
import { buildValidations, validator } from 'ember-cp-validations';

export default buildValidations({
  parts: [validator('has-many')],
});
